import { z } from 'zod';
import { communicationsChannelSchema, communicationsMessageStateSchema, } from './communications-message.contract.js';
export const communicationsInsuranceClaimsNoticeDeliveryCapability = 'communications.insurance-claim-notice-delivery.v1';
export const communicationsInsuranceClaimsNoticeDeliverySlot = 'insurance-claims.notice-delivery';
export const communicationsInsuranceClaimsNoticeDeliveryProviderId = 'communications.server.insurance-claims-notice-delivery';
const idSchema = z.string().uuid();
const sha256Schema = z.string().regex(/^[a-f0-9]{64}$/);
export const communicationsInsuranceClaimsNoticeDeliveryRequestSchema = z.strictObject({
    consumerModuleId: z.literal('insurance-claims'),
    requestedCapability: z.literal(communicationsInsuranceClaimsNoticeDeliveryCapability),
    resourceType: z.literal('insurance-claims.aob-notice'),
    resourceId: idSchema,
    projectId: idSchema,
});
export const communicationsInsuranceClaimsNoticeDeliveryFactSchema = z.strictObject({
    capability: z.literal(communicationsInsuranceClaimsNoticeDeliveryCapability),
    noticeId: idSchema,
    projectId: idSchema,
    messageId: idSchema,
    threadId: idSchema,
    sourceVersion: z.number().int().positive(),
    contentHash: sha256Schema,
    channel: communicationsChannelSchema,
    state: communicationsMessageStateSchema,
    sentAt: z.string().datetime({ offset: true }).nullable(),
    deliveredAt: z.string().datetime({ offset: true }).nullable(),
    observedAt: z.string().datetime({ offset: true }),
}).superRefine((value, context) => {
    if (['sent', 'delivered'].includes(value.state) && value.sentAt === null) {
        context.addIssue({
            code: 'custom',
            path: ['sentAt'],
            message: 'Sent and delivered facts require the transport send time.',
        });
    }
    if ((value.state === 'delivered') !== (value.deliveredAt !== null)) {
        context.addIssue({
            code: 'custom',
            path: ['deliveredAt'],
            message: 'Only a delivered fact carries the exact receipt time.',
        });
    }
});
export const communicationsInsuranceClaimsNoticeDeliveryResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(communicationsInsuranceClaimsNoticeDeliveryCapability),
    noticeId: idSchema,
    projectId: idSchema,
    facts: z.array(communicationsInsuranceClaimsNoticeDeliveryFactSchema).max(500),
}).superRefine((value, context) => {
    const messageIds = value.facts.map(({ messageId }) => messageId);
    if (new Set(messageIds).size !== messageIds.length) {
        context.addIssue({
            code: 'custom',
            path: ['facts'],
            message: 'Notice delivery facts must contain each message once.',
        });
    }
    value.facts.forEach((fact, index) => {
        if (fact.noticeId !== value.noticeId || fact.projectId !== value.projectId) {
            context.addIssue({
                code: 'custom',
                path: ['facts', index],
                message: 'Notice delivery facts must belong to the requested notice and Project.',
            });
        }
    });
});
//# sourceMappingURL=communications-insurance-claims-notice-delivery.contract.js.map